import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const AlertOutline = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            d="M12,17.8906 C11.277,17.8906 10.691,17.3046 10.691,16.5816 C10.691,15.8586 11.277,15.2726 12,15.2726 C12.723,15.2726 13.3092,15.8586 13.3092,16.5816 C13.3092,17.3046 12.723,17.8906 12,17.8906 Z M13.421,7.7718 L12.9162,13.7016 C12.9162,14.2076 12.506,14.6178 12,14.6178 C11.494,14.6178 11.0836,14.2076 11.0836,13.7016 L10.579,7.7718 C10.5678,7.6992 10.56,7.6252 10.56,7.549 C10.56,6.7538 11.205,6.1092 12,6.1092 C12.7954,6.1092 13.44,6.7538 13.44,7.549 C13.44,7.6252 13.4324,7.6992 13.421,7.7718 Z"
        />
    </StarryUIIcon>
);
